module.exports = __webpack_public_path__ + "static/media/remove.cdf1ef7d.svg";